import { render, staticRenderFns } from "./DirectReferralForm.vue?vue&type=template&id=26b200a1&scoped=true"
import script from "./DirectReferralForm.vue?vue&type=script&lang=js"
export * from "./DirectReferralForm.vue?vue&type=script&lang=js"
import style0 from "./DirectReferralForm.vue?vue&type=style&index=0&id=26b200a1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26b200a1",
  null
  
)

export default component.exports